const DEFAULT_JUNIPER = '#33cb9a'

module.exports = {
  transparent: 'transparent',
  current: 'currentColor',
  black: '#000000',
  github: '#414141',
  gitlab: '#6753b5',
  bitbucket: '#1e54c5',
  lavender: '#7a97fa',
  lilac: '#c97bd4',
  'sea-glass': '#49f9cf',
  pink: '#f977ff',
  purple: '#986EE2',
  'light-juniper': '#2eb78b', // legacy
  'light-cherry': '#d6435b', // legacy
  amber: '#F4900C',
  contentLowEmphasis: '#979799',
  juniper: {
    DEFAULT: DEFAULT_JUNIPER,
    // old scale
    600: '#2eb78b',
    500: DEFAULT_JUNIPER,
    400: '#53d4aa',
    300: '#74dcba',
    200: '#94e4ca',
    150: '#a5e8d2',
    100: '#b5ecda',
    // new scale
    1: '#FAFEFC',
    2: '#F2FCF7',
    3: '#E0F8ED',
    4: '#CDF3E2',
    5: '#B7ECD4',
    6: '#9BE2C4',
    7: '#73D3AE',
    8: '#1CBF8F',
    9: DEFAULT_JUNIPER,
    10: '#1EC08F',
    11: '#00825B',
    12: '#0B3D2C'
  },
  robin: {
    DEFAULT: '#4568dc',
    600: '#2449c1',
    500: '#4568dc',
    400: '#6784e2',
    200: '#acbcef',
    300: '#8aa0e9',
    150: '#bdcaf3',
    100: '#ced8f6'
  },
  cherry: {
    DEFAULT: '#da5565',
    600: '#d6435b',
    500: '#da5565',
    400: '#e17783',
    300: '#e998a2',
    200: '#f0bac0',
    150: '#f4cacf',
    100: '#f7dbde'
  },
  honey: {
    DEFAULT: '#f6d87c',
    600: '#f0bf28',
    500: '#f6d87c',
    400: '#f9e3a2',
    300: '#fbefc8',
    200: '#fefaef',
    150: '#ffffff',
    100: '#ffffff'
  },
  tangerine: {
    DEFAULT: '#ee7c4b',
    600: '#e5612a',
    500: '#ee7c4b',
    400: '#f29670',
    300: '#f6b095',
    200: '#facabb',
    150: '#fcd7cc',
    100: '#fde4dd'
  },
  aqua: {
    DEFAULT: '#23c4f8',
    600: '#07aade',
    500: '#23c4f8',
    400: '#4bcff9',
    300: '#72d9fb',
    200: '#9ae4fc',
    150: '#ade9fc',
    100: '#c1eefd'
  },
  ink: {
    50: '#303540',
    100: '#2a2e37',
    200: '#23262e',
    300: '#16181d',
    400: '#121317'
  },
  slate: {
    DEFAULT: '#52575c',
    200: '#52575c',
    300: '#24272b',
    400: '#1d2023'
  },
  vanilla: {
    100: '#ffffff',
    200: '#f5f5f5',
    300: '#eeeeee',
    400: '#c0c1c3'
  },
  gray: {
    1: '#FCFCFD',
    2: '#F8F9FB',
    3: '#EFF0F4',
    4: '#E6E8ED',
    5: '#DFE1E7',
    6: '#D7DAE1',
    7: '#CBCFD7',
    8: '#B7BCC6',
    9: '#8A8E98',
    10: '#7F838D',
    11: '#60646D',
    12: '#1D1F25'
  }
}
